<template>
  <section>
    <el-container>
      <el-header class="header" height="65px">
        <section class="logo"><img :src="Logo" height="44px"></section>
        <section class="center" style="height: 65px; position: relative;left: 5rem; z-index: 5;">
          <el-menu
            :default-active="activeIndex"
            text-color="#fff"
            class="nav"
            mode="horizontal"
            @select="handleSelect">
            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2">人才招聘</el-menu-item>
            <!-- <el-menu-item index="3">通知公告</el-menu-item> -->
            <el-menu-item index="4">企业介绍</el-menu-item>
          </el-menu>
        </section>
      </el-header>
      <el-main class="my-main">
        <router-view/>
      </el-main>
    </el-container>
    <div class="footer-wrapper">
      <el-row class="home-row">
        <el-col :span="16" :offset="4">
          <div class="layout footer">
            <div class="copyleft" >
              <p>公司地址：江苏省徐州市和平大道126-9号地铁大厦 邮编：221009</p>
              <p>徐州市轨道交通工程建设指挥部 徐州地铁集团有限公司 版权所有 <a href="/article/0/NOTICE/2237.html" style="color: #787878;">网站声明</a></p>
            </div>
            <div class="copyright">
              <div class="imgParentDiv">
                <div :style="{backgroundImage: 'url(' + tcImg + ')'}" class="tancengDiv">
                  <img src="../../assets/img/wechat.jpeg">
                </div>
                <img ref="ImgWechat" src="../../assets/PC/weixin_icon_home.png" alt="" style="float: left;left: 100px; width: 70%;">
              </div>
              <div>
                <span style="">关注公众号</span><br />
                <span style=";">&nbsp;&nbsp;&nbsp;抢占优惠先机</span>
              </div>
            </div>
            <div class="copyright">
              <div class="imgParentDiv">
                <div :style="{backgroundImage: 'url(' + tcImg + ')'}" class="tancengAppDiv">
                  <img src="../../assets/img/app.png">
                </div>
                <img ref="ImgApp" src="../../assets/PC/ditielogo_icon_home.png" alt="" style="float: left;left: 100px; width: 70%;">
              </div>
              <div>
                <span style=";">关注公众号</span><br />
                <span style="">&nbsp;&nbsp;&nbsp;抢占优惠先机</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </section>
</template>
<style>
  .imgParentDiv{
    position: relative;
  }
  .imgParentDiv:hover .tancengDiv{
    display: block;
  }
    .imgParentDiv:hover .tancengAppDiv{
    display: block;
  }
  .tancengDiv{
    display: none;
    position: absolute;
    top: -227px;
    right: -40px;
    width: 220px;
    height: 227px;
    background: no-repeat center;
    background-color:transparent;
    background-size: 100% 100%;
    z-index: 999;
    text-align: center;
    vertical-align: middle;
  }
  .tancengDiv>img{
    width: 200px;
    height: 200px;
  }
  .tancengAppDiv{
    display: none;
    position: absolute;
    top: -227px;
    right: -40px;
    width: 220px;
    height: 227px;
    background: no-repeat center;
    background-color:transparent;
    background-size: 100% 100%;
    z-index: 999;
    text-align: center;
    vertical-align: middle;
  }
  .tancengAppDiv>img{
    width: 200px;
    height: 200px;
  }
  .footer-wrapper {
    margin-top: 20px;
    background-color: #0b0b0a;
    text-align: center;
    padding: 10px;
  }
  .copyleft{
    float: left;
    display: inline-block;
    vertical-align: middle;
    -webkit-flex: 1;
    flex: 1.6;
    line-height: 1.0;
    text-align: left;
  }
  .copyright{
    display: flex;
    justify-content:space-around;
    margin-left: 30px;
    font-size: 8px;
  }
  .footer {
  font-size: 12px;
    color: #787878;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
  .layout {
    margin: auto;
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    border-bottom-color: #C03639;
    color: #fff;
    font-size: 12px;
  }
  .el-menu-item.is-active {
    /*background-color: blue;*/
    border-bottom-color: rgb(206,43,24);
    height: 70px;
    background-color: rgb(206,43,24);
  }
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
    background-color:rgb(206,43,24);
    border-bottom: none;
    height: 70px;
    color: #fff;
    font-size: 12px;
  }
  .el-menu-item{
    padding: 0 15px;
    height: 70px;
    line-height: 70px;
    background: transparent;
    font-size: 12px;
  }
  .nav.el-menu.el-menu--horizontal{
    background: transparent;
  }
  .el-card{
    border: none;
  }
</style>
<script>
import Logo from 'assets/img/logo_home@2x.png'
import tcImg from 'assets/img/tc.png'
import alimask from 'alimask'
export default {
  data: () => {
    return {
      Logo,
      tcImg,
      activeIndex: '1',
      wechatShow: false,
      appShow: false,
      curTop: 0,
      curLeft: 0
    }
  },
  computed: {
    routeMetaIndex() {
      if (this.$route.meta.hasOwnProperty('index')) {
        return this.$route.meta.index
      } else {
        return '1'
      }
    }
  },
  watch: {
    routeMetaIndex(val) {
      this.updateActiveIndex(val)
    }
  },
  created() {
    var base64Bg = alimask('徐州地铁', { font: '24px Arial' })
    // window.document.body.background = base64Bg
    window.document.body.style.backgroundColor = '#F3F4F8'
    this.updateActiveIndex(this.routeMetaIndex)
  },
  methods: {
    updateActiveIndex(val) {
      this.activeIndex = val
    },
    showQR(objName, status = 0) {
      if (status === 0) {
        if (objName === 1) {
          this.wechatShow = false
        } else {
          this.appShow = false
        }
      } else {
        if (objName === 1) {
          this.curTop = this.$refs.ImgWechat.getBoundingClientRect().top - 230
          this.curLeft = this.$refs.ImgWechat.getBoundingClientRect().left - 140
          this.wechatShow = true
        } else {
          this.curTop = this.$refs.ImgApp.getBoundingClientRect().top - 230
          this.curLeft = this.$refs.ImgApp.getBoundingClientRect().left - 140
          this.appShow = true
        }
      }
    },
    handleSelect(key, keyPath) {
      var path = '/home'
      switch (key) {
        case '1':
          path = '/home'
          break
        case '2':
          path = '/recruit'
          break
        case '3':
          path = '/announcement'
          break
        case '4':
          path = '/companyProfile'
          break
      }
      this.$router.push(path)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/layout/layout.vue